import type { PackagingListTabId } from "./PackagingListContext";

type PackagingListExportTarget = {
    path: string;
    fileNameStem: string;
};

export const packagingListExportTarget = (tab: PackagingListTabId): PackagingListExportTarget => {
    if (tab === "elements") return { path: "/api/packaging-elements", fileNameStem: "packaging-elements" };
    if (tab === "composites") return { path: "/api/packaging-composites", fileNameStem: "packaging-composites" };

    return { path: "/api/packagings", fileNameStem: "packagings" };
};
